import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, axiosConfig } from '../config';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, axiosConfig);
      setUser(response.data);
    } catch (error) {
      console.error('Ошибка проверки авторизации:', error);
      // Если токен невалиден, пользователь будет null
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/login`,
        { email, password },
        axiosConfig
      );
      
      // Токен теперь в cookie, получаем только user
      setUser(response.data.user);
      
      return { success: true };
    } catch (error) {
      console.error('Ошибка входа:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Ошибка входа'
      };
    }
  };

  const logout = async () => {
    try {
      await axios.post(`${API_BASE_URL}/auth/logout`, {}, axiosConfig);
    } catch (error) {
      console.error('Ошибка выхода:', error);
    }
    setUser(null);
  };

    const value = {
        user,
        loading,
        login,
        logout,
        updateUser: data => setUser(previous => ({...previous,...data})),
        isAuthenticated: !!user
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

